import React, { useEffect, useState } from 'react';
import { useAppDispatch } from '../../../core/redux';
import { App, Button, Form, Input, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import {
  ExclamationCircleOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
  UnlockOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { IGetToken } from '../interfaces/authorization-interfaces';
import StorageService from '../../../common/helpers/storageService/storage-service';
import { localStorage, routes } from '../../../../types/types';
import { XPathLogo } from '../../../common/components/xPathLogo/xPathLogo';
import { authService } from '../../../api/authService/authService';
import { authorizationSlice } from '../AuthorizationSlice';
import { defaultData } from '../../../../index';

import s from './Auth.module.scss';

type FieldType = {
  login?: string;
  password?: string;
};

const validateMessages = {
  required: '${label} is required!',
  types: {
    email: '${label} is not a valid email!',
    number: '${label} is not a valid number!',
  },
};

const { setIsAuth } = authorizationSlice.actions;
export const Auth = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { notification } = App.useApp();
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [fetchAuth, { isError, error: tokenError, status, isLoading }] =
    authService.useGetSignInTokenMutation();

  const handleChangeLogin = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const value = e.target.value;
    setLogin(value);
  };
  const handleChangePassword = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const value = e.target.value;
    setPassword(value);
  };

  const onFinish = (values: IGetToken) => {
    fetchAuth(values);
  };

  const onFinishFailed = (errorInfo: unknown) => {
    console.log('Failed:', errorInfo);
  };

  const showNotification = (message) => {
    notification.info({
      message: message,
      description: 'Не удалось авторизоваться',
      placement: 'topLeft',
      icon: <ExclamationCircleOutlined style={{ color: defaultData.errorColor }} />,
    });
  };

  useEffect(() => {
    if (!isError && status === 'fulfilled') {
      StorageService.set(localStorage.token, true);
      dispatch(setIsAuth(true));
    } else if (isError && tokenError) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      showNotification(tokenError?.data?.detail || tokenError.error);
      StorageService.set(localStorage.token, false);
    }
  }, [status, isError, tokenError]);

  useEffect(() => {
    navigate(routes.login);
  }, [navigate]);

  const renderForm = () => {
    return (
      <Form
        className={s.authForm}
        name='basic'
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        // autoComplete='off'
        validateMessages={validateMessages}
      >
        <div className={s.header}>
          <h1>Вход в аккаунт</h1>
        </div>

        <Form.Item<FieldType>
          // label='Username'
          name='login'
          rules={[{ required: true, type: 'email' }]}
        >
          <Input
            value={login}
            onChange={handleChangeLogin}
            placeholder='Эл. адрес'
            prefix={<UserOutlined className='site-form-item-icon' />}
            size={'large'}
          />
        </Form.Item>

        <Form.Item<FieldType>
          // label='Password'
          name='password'
          rules={[{ required: true, message: 'Please input your password!' }]}
        >
          <Input.Password
            value={password}
            onChange={handleChangePassword}
            placeholder='Пароль'
            prefix={<UnlockOutlined className='site-form-item-icon' />}
            iconRender={(visible) =>
              visible ? (
                <EyeOutlined className='site-form-item-icon' />
              ) : (
                <EyeInvisibleOutlined className='site-form-item-icon' />
              )
            }
            size={'large'}
          />
        </Form.Item>

        <div className={s.forgot_password}>
          <Button type={'link'}>Забыли пароль?</Button>
        </div>

        <Form.Item>
          <Button htmlType='submit' type='primary' block size={'large'}>
            Войти
          </Button>
        </Form.Item>
      </Form>
    );
  };

  return (
    <div className={s.Auth}>
      <div className={s.logo}>
        <XPathLogo />
      </div>
      <Spin tip='Loading...' spinning={isLoading} size='large'>
        {renderForm()}
      </Spin>
    </div>
  );
};
